<template>
  <div class="md-layout">
    <div class="isis-modal-header">
      <div class="flex items-start">
        <span class="min-w-[145px] font-medium">{{
          this.$t("survey_report.responded_detail") + ": "
        }}</span>
        <span class="pl-2" v-html="questionTitle"></span>
      </div>
      <div class="flex items-start">
        <button class="btn-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <p class="pb-4 text-sm">
      {{ answerDetail.count_answer }} {{ $t("survey_report.responses") }}
    </p>
    <div class="md-layout-item md-size-100 p-0">
      <YvTable
        :tableData="answerDetail.data"
        :pagination="pagination"
        :columns="columns"
        :hideAction="true"
        :hideNoNumber="true"
        :hideBulkAction="true"
        :sort-data="sortData"
      />
      <div class="flex w-full text-right">
        <Pagination
          :value="pagination.pageNumber"
          :perPage="pagination.perPage"
          :total="pagination.total"
          @input="changePage"
        />
      </div>
    </div>
    <div class="md-layout-item md-size-100 flex text-center">
      <md-button class="md-raised" @click="closeModal">{{
        $t("common.close")
      }}</md-button>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import YvTable from "@/components/Base/YvTable";
import Pagination from "@/components/Pagination";

export default {
  props: ["modalName", "questionTitle"],
  components: {
    YvTable,
    Pagination
  },
  data() {
    return {
      answerDetail: {},
      columns: {
        no: "common.no_number",
        respondent_email: "survey_report.respondent_email",
        respondent_name: "survey_report.respondent_name",
        responses: "survey_report.responses"
      },
      pagination: {
        pageNumber: 1,
        total: 0,
        perPage: 5,
        hidePerPageOptions: true
      },
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      }
    };
  },
  created() {
    this.getAnswerDetail();
  },
  computed: {
    surveyId() {
      return this.$route.params.id;
    }
  },
  methods: {
    getAnswerDetail() {
      this.$axios
        .get(`${service_paths.report_surveys}/question`, {
          survey_id: this.surveyId,
          question_title: this.questionTitle,
          page: this.pagination.pageNumber,
          limit: this.pagination.perPage
        })
        .then(res => {
          this.pagination.total = res.data.count_answer;
          this.answerDetail = res.data;
        });
    },
    changePage(value) {
      this.pagination.pageNumber = value;
      this.getAnswerDetail();
    },
    closeModal() {
      this.$modal.hide(this.modalName);
    }
  }
};
</script>
<style lang="scss" scoped>
.isis-modal-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  .title {
    padding: 0;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
  button.btn-close {
    padding: 5px 8px;
    border: none;
    background-color: transparent;
    transition: 0.15s;
    cursor: pointer;
    border-radius: 3px;

    &:focus {
      outline: none;
      border: none;
    }

    &:hover {
      background-color: rgba(gray, 0.4);
    }

    i {
      font-size: 16px;
      color: gray;
    }
    i.edit-icon {
      color: green;
    }
    i.view-icon {
      color: #ff9800;
    }
  }
}
</style>
